"use strict";
/*
 * TODO: implement Redux and localStorage
 * For now, mimic implementation of OMRestAPiClient
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const profile_photos_json_1 = __importDefault(require("../data/profile_photos.json"));
const review_photos_json_1 = __importDefault(require("../data/review_photos.json"));
const reviews_json_1 = __importDefault(require("../data/reviews.json"));
const users_json_1 = __importDefault(require("../data/users.json"));
const venues_json_1 = __importDefault(require("../data/venues.json"));
class OMLocalFileApiClient {
    constructor() {
        this.requestHeaders = {};
    }
    // public api: AxiosInstance
    /* METHOD: OMApiClientProtocol */
    send(config) {
        switch (config.method) {
            case "GET":
                const jsonResponse = (() => {
                    switch (config.url) {
                        case "users":
                            return users_json_1.default;
                        case "profile_photos":
                            return profile_photos_json_1.default;
                        case "review_photos":
                            return review_photos_json_1.default;
                        case "venues":
                            return venues_json_1.default;
                        case "reviews":
                            return reviews_json_1.default;
                        default:
                            break;
                    }
                })();
                if (!jsonResponse) {
                    Promise.reject(new Error(`config.url: ${config.url} is not supported`));
                }
                return Promise.resolve({
                    data: jsonResponse,
                });
            case "POST":
                return (() => {
                    if (!config.data) {
                        return Promise.reject(new Error("Undefined data parameter"));
                    }
                    // TODO: handle config.data that have type any[]
                    __1.OMUniverse.shared.cache.dispatch({
                        data: config.data,
                        type: "insert",
                    });
                    return Promise.resolve(""); // TODO:
                })();
            case "PATCH":
            // TODO: Future implementation
            /* return (() => {
                if (!config.data) {
                    return Promise.reject(new Error("Undefined data parameter"))
                }

                if (!config.url) {
                    return Promise.reject(new Error("config.url is not provided"))
                }

                const baseObj = ((OMUniverse.shared.cache.getState() as any)[config.url]
                        .data as OMObjectProperties[])
                        .find((item) => item.objectUuid === (config.data as OMObjectProperties).objectUuid)

                if (!baseObj) {
                    return Promise.reject(new Error("Existing object not found"))
                }

                // TODO: handle config.data that have type any[]
                // compute difference between current object in redux store and config.data object
                const difference: any = JsonUtils.difference(config.data, baseObj)

                if (Object.keys(difference).length === 0) {
                    return Promise.resolve(config.data)
                }

                OMUniverse.shared.cache.dispatch({
                    data: config.data,
                    difference,
                    type: `${config.url}.Update`,
                    url: config.url,
                })
                return Promise.resolve("" as any) // TODO:
            })() */
            default:
                return Promise.resolve(""); // TODO:
        }
    }
    /* METHOD: OMApiClientProtocol */
    objectsFromResponse(T, response) {
        const objects = __1.JsonUtils.transformObject(response);
        return objects.map((object) => new T(object));
    }
}
exports.default = OMLocalFileApiClient;
//# sourceMappingURL=OMLocalFileApiClient.js.map